<template>
<div class="card float-e-margins" >
  <div class="card-title">
      <h1>Speciaal voor jou gevonden deze week !</h1>
  </div>
  <div class="card-content no-padding">
    <div class="row">
      <div class="slider">
        <img v-for="i in 15" class="carousel-cell" :src="products[i].Photos[0].URL" alt="" v-link="{ name: 'Product', params: { id: products[i].ProductId, pname: $options.filters.slugurl(products[i].Name) }}" style="cursor:pointer" />
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <h2>Welkom</h2>
        <p>
        bij Catootjeskraam.
        </p>
        <p>
        Catootjeskraam is een webshop in o.a. antiek,
        <a v-link="{ name: 'categorie', params: { id: 15, cname: 'stoer-' }}">stoer</a>,
        <a v-link="{ name: 'categorie', params: { id: 3, cname: 'curiosa' }}">curiosa</a>,
        <a v-link="{ name: 'categorie', params: { id: 100002, cname: 'diversen' }}">diversen</a>,
        <a v-link="{ name: 'categorie', params: { id: 100003, cname: 'anton-pieck' }}">Anton Pieck</a>
        en nog vele andere kraampjes die in September 2016 online is gegaan.
        </p>
        <p>
          Dagelijks zijn wij op zoek naar unieke items in binnen- en buitenland, zodat wij wekelijks onze collectie kunnen aanvullen.
          <br> Zo blijft het leuk om geregeld onze webshop te bezoeken.
          <br> In onze slideshow staan de laatste nieuwe aanwinsten die we speciaal voor jou gevonden hebben,
          <br> en waarmee je je interieur een eigen draai kunt geven.
        </p>
        <p>
        Veel kijkplezier in onze webshop!
        </p>
        <p>
        Oh ja, Catootjeskraam heeft de volgende openingstijden:
         <br> 24 uur per dag.
         <br> 7 dagen per week.
         <br> 365 dagen per jaar.
        </p>
        <p>
        <strong>
          Wij verzenden wereldwijd 
          <br> We offer global shipping
        </strong>
        </p>
        <p>
          Heb je nog een vraag, stuur ons dan gerust een <a href="mailto:info@catootjeskraam.nl">e-mailtje</a>.
        </p>
      </div>
    </div>    
  </div>
</div>
</template>

<script>
import store from '../store'
import Flickity from 'flickity'

export default {
  components: {
  },
  data () {
    return {
      // note: changing this line won't causes changes
      // with hot-reload because the reloaded component
      // preserves its current state and we are modifying
      // its initial state.
      msg: 'Catootjes kraam staat voor Antiek, Brocante en Curiosa.',
      store: store,
      products: {}
    }
  },
  methods: {
    getProducts: function () {
      $.ajax({
        type: 'GET',
        url: store.root + 'api/Products/last',
        dataType: 'json',
        xhrFields: {
          withCredentials: true
        },
        success: function (response) {
          this.products = response
        }.bind(this)
      })
    },
    initSlider: function () {
      var elem = document.querySelector('.slider')
      return new Flickity(elem, {
      // options
        contain: true,
        autoPlay: 2500,
        pauseAutoPlayOnHover: false
      })
    }
  },
  created () {
    this.getProducts()
  },
  ready () {
    this.initSlider()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.slider {
  background: #EEE;
}

.carousel-cell {
  width: 400px;
  height: 250px;
  margin-right: 10px;
  border-radius: 5px;
  counter-increment: gallery-cell;
}

/* cell number */
.carousel-cell:before {
  display: block;
  text-align: center;
  content: counter(gallery-cell);
  line-height: 250px;
  font-size: 80px;
  color: white;
}
.flickity-prev-next-button:focus {
  outline: none;
  box-shadow: 0 0 0 5px #09F;
}

p {
  font-size: 130%;
}
</style>



// WEBPACK FOOTER //
// Hello.vue?7a695672